var AutoFocusDirective = {
    bind: function (element) {
        // If this doesn't work in some case, try window.setTimeout.
        Promise.resolve().then(function () {
            element.focus();
        });
    },
};
export default AutoFocusDirective;
